import React from 'react'
import { google, auth , db} from '../configs/firebaseconfig';
import { doc, getDoc , setDoc} from "firebase/firestore";
import {signInWithPopup} from "firebase/auth";

import {SiGoogle} from "react-icons/si";
import {MdOutlineClose} from "react-icons/md";

export default function Login({showLogin, setShowLogin, setUser}) {
  const login = async(provider) => {
    try {
      
      const result = await signInWithPopup(auth, provider) 
      setUser(result.user)
      
      setShowLogin(false)
      const docRef = doc(db, "users", result.user.uid);
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
        await setDoc(doc(db, "users",  result.user.uid), {
          username: result.user.displayName,
          recipes: [],
          saved: []
        });      
       
      }
     
    } catch(err) {
     console.log(err)
    }
    
  }
  if(showLogin  === false ) return null

  return (
    <>
    <div className="overlay" onClick={()=>{setShowLogin(false)}}></div>
    <div className="login popup">
      <div className="left">
        <div>
          <h3>Welcome to our recipe site!</h3>
          <p> To access all of our delicious recipes and cooking tips, please login to your account. If you don't have an account yet, you can easily create one by clicking on the "Login" button. Once you've logged in, you'll be able to save your favorite recipes, and even blogin your own racepies. Happy cooking!</p>
        </div>
       <div>
       <button className='center' 
        onClick={() => login(google)}>
          <SiGoogle/>
          Login with Google
      </button> 
       <div className="center latter"
        onClick={() => setShowLogin(false)}>
         
          <MdOutlineClose/>
      </div> 
      
       </div>

        
      </div>
      <div className="img-cont">
      <img src="/chef3.jpg" alt="" />
    </div>
    </div>
    
    </>
  )
}
